import { helpers, React, ts, ui, useSelector } from '_core';

import { prepareExposureData } from './helpers';
import { Params } from './types';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  file: string;
  fullScreen: boolean;
  params: Params;
  title: string;
  context: ts.types.basket.BasketAnalysisContext;
};

const Chart = ({ id, readOnly, loadWidgetData, file, params, context, fullScreen, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [alert, setAlert] = React.useState<{ type: 'error' | 'warning'; message: string } | null>(null);
  const resources = useSelector((state) => state.resources);

  const signalHandle = React.useMemo(() => {
    return params.factors?.[0]?.value;
  }, [params.factors]);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file,
          rename: { build_date: 'date' },
        },
      });

      if (response) setData(prepareExposureData(response.data, context, signalHandle, resources, context.basket_id));
    } catch (err) {
      setAlert({
        type: 'error',
        message: helpers.parseApiError(err as ts.types.common.ApiError),
      });
    }
  };

  React.useEffect(() => {
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      alert={alert}
      readOnly={readOnly}
      exportTitle={title}
      yAxisLabel="Exposures"
      fullScreen={fullScreen}
    />
  );
};

export default Chart;
